import { CJEDTEvent } from '@teetsh/app/src/types/event';
import getDay from '@teetsh/app/src/utils/time/getDay';
import _some from 'lodash-es/some';

export function getEventsOfClassroomAndDay(
  events: CJEDTEvent[],
  day: number,
  classroomIds: string[],
): CJEDTEvent[] {
  return events.filter(
    e =>
      getDay(e.start) === day &&
      _some(e.classroomIds, clId => classroomIds.includes(clId)),
  );
}
